import $ from "jquery";
import "slick-carousel";
import AOS from "aos";
import lozad from "lozad";

$(function () {
	"use strict";

	// $( "<div class='grid-container' style='position: relative;'>Test</div>" ).insertAfter( "#ImageGallery" );

	// Slick sliders
	$(".TestimonialsSlider-slick").on("init", function (event, slick) {
		AOS.init();
		const observer = lozad(); // lazy loads elements with default selector as ".lozad"
		observer.observe();
	});

	$(".TestimonialsSlider-slick").slick({
		dots: true,
		rows: 0,
	});


});


import "../../node_modules/slick-carousel/slick/slick.css";
import "../../node_modules/slick-carousel/slick/slick-theme.css";
